import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { AddChildStore } from "./AddChildStore";
import { AddParentStore } from "./AddParentStore";
import { UpdateChildStore } from "./UpdateChildStore";
import { UpdateUserNote } from "./UpdateUserNote";

export class FamilyStore {
  showDlg = false;
  loading = false;
  family: any = { parents: [] };

  userId = null;
  childId = null;
  curUser: any = null;

  addChild: AddChildStore;
  addParent: AddParentStore;
  updateChild: UpdateChildStore;
  updateNote: UpdateUserNote;

  constructor() {
    makeAutoObservable(this, {});
    this.addChild = new AddChildStore(this);
    this.addParent = new AddParentStore(this);
    this.updateChild = new UpdateChildStore(this);
    this.updateNote = new UpdateUserNote(this);
  }

  @action show(userId, childId) {
    this.userId = userId;
    this.childId = childId;
    this.showDlg = true;
    this.family = { parents: [] };
    return this.loadData();
  }
  @action close() {
    this.showDlg = false;
  }

  @action loadData() {
    this.loading = true;

    this.updateChild.init()
    this.addChild.init()
    
    return Api.family
      .get(this.userId, this.childId)
      .then((res) => {
        runInAction(() => {
          this.family = res.data.family;
          if (this.family.parents.length > 0) {
            this.curUser = this.family.parents[0];
          }
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const familyStore = new FamilyStore();
